/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface CreatedResult {
  location?: string | null;
  value?: any | null;
  formatters?: Array<object> | null;
  contentTypes?: Array<string> | null;
  declaredType?: string | null;
  statusCode?: number | null;
}
